import axios from 'src/store/vue-axios/axios.js'

export default class Registration {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // REGISTRATION -> /registration/*
  static informationUrl = () => '/registration/information'
  static checkEmailUrl = () => '/registration/check-email'
  static checkUsernameUrl = () => '/registration/check-username'

  // ACTIVATIONKEY -> /registration/activationkey*
  static activationKeyRegisterUrl = () => '/registration/activationkey/register'
  static activationKeyStepsUrl = () => '/registration/activationkey/steps'

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // REGISTRATION -> /registration/*
  static async getInformation (config) {
    return axios.get(this.informationUrl(), config)
  }

  static async postCheckEmail (payload) {
    return axios.post(this.checkEmailUrl(), payload)
  }

  static async postCheckUsername (payload) {
    return axios.post(this.checkUsernameUrl(), payload)
  }

  // ACTIVATIONKEY -> /registration/activationkey*
  static async postActivationKeyRegister (payload) {
    return axios.post(this.activationKeyRegisterUrl(), payload)
  }

  static async getActivationKeySteps (config) {
    return axios.get(this.activationKeyStepsUrl(), config)
  }
}
